<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="cont" epub:type="toc" role="doc-toc">
<header>
<h1 class="FMH" id="cont"><span aria-label=" Page v. " epub:type="pagebreak" id="pg_v" role="doc-pagebreak"><span class="small">CONTENTS</span></span></h1>
</header>
<ol class="toc">
<li class="CFMH"><a href="#/xhtml/notetoreader"><i>Note on Transliteration and Pronunciation of Names and Terms</i></a></li>
<li class="CCTF"><a href="#/xhtml/introduction">Introduction: Why Study Women in the Buddhist Traditions?</a></li>
<li class="CCT"><a href="#/xhtml/chapter1">1.  Women in Early Indian Buddhism</a></li>
<li class="CCT"><span href="#/xhtml/chapter2" title="Link target outside of Sample">2.  Buddhist Women in South and Southeast Asia</span></li>
<li class="CCT"><span href="#/xhtml/chapter3" title="Link target outside of Sample">3.  Buddhist Women in East Asia</span></li>
<li class="CCT"><span href="#/xhtml/chapter4" title="Link target outside of Sample">4.  Buddhist Women in Inner Asia</span></li>
<li class="CCT"><span href="#/xhtml/chapter5" title="Link target outside of Sample">5.  Buddhist Women in the West</span></li>
<li class="CCT"><span href="#/xhtml/chapter6" title="Link target outside of Sample">6.  Women’s Ordination across Cultures</span></li>
<li class="CCT"><span href="#/xhtml/chapter7" title="Link target outside of Sample">7.  Grassroots Revolution: Buddhist Women and Social Activism</span></li>
<li class="CCT1"><span href="#/xhtml/conclusion" title="Link target outside of Sample">Conclusion</span></li>
<li class="CBMHF"><span href="#/xhtml/acknowledgments" title="Link target outside of Sample"><i>Acknowledgments</i></span></li>
<li class="CBMH"><span href="#/xhtml/discussion" title="Link target outside of Sample"><i>Questions for Discussion</i></span></li>
<li class="CBMH"><span href="#/xhtml/furtherreading" title="Link target outside of Sample"><i>For Further Reading</i></span></li>
<li class="CBMH"><span href="#/xhtml/notes" title="Link target outside of Sample"><i>Notes</i></span></li>
<li class="CBMH"><span href="#/xhtml/workcited" title="Link target outside of Sample"><i>Works Cited</i></span></li>
<li class="CBMH"><span href="#/xhtml/index" title="Link target outside of Sample"><i>Index</i></span></li>
<li class="CBMH"><span href="#/xhtml/abouttheauthor" title="Link target outside of Sample"><i>About the Author</i></span><span aria-label=" Page vi. " epub:type="pagebreak" id="pg_vi" role="doc-pagebreak"></span></li>
</ol>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?29550ba3